import { ResponsivePictureLayout } from '@news-mono/component-library'
import { layout } from '../../../App.routing'
import { GetMainSectionFn } from '../custom-topic-routes'

const desktopBanner = require<string>('./assets/food/Desktop.jpg')
const tabletBanner = require<string>('./assets/food/Tablet.jpg')
const mobileBanner = require<string>('./assets/food/Mobile.jpg')

export const getFoodRouteInfo: GetMainSectionFn = (sectionBuilder) => {
    return [
        layout.component({
            type: 'image-banner',
            props: {
                defaultSrc: mobileBanner,
                verticalGutters: ['unset', 'md'],
                altText: 'Food Reviews Banner',
                hiddenHeading: 'Food',
                sources: [
                    {
                        breakpoint: 'md',
                        src: [
                            {
                                src: desktopBanner,
                                density: '2x',
                            },
                            {
                                src: desktopBanner,
                                density: '1x',
                            },
                        ],
                    },
                    {
                        breakpoint: 'xs',
                        src: [
                            {
                                src: tabletBanner,
                                density: '2x',
                            },
                            {
                                src: tabletBanner,
                                density: '1x',
                            },
                        ],
                    },
                    {
                        src: [
                            {
                                src: mobileBanner,
                                density: '2x',
                            },
                            {
                                src: mobileBanner,
                                density: '1x',
                            },
                        ],
                    },
                ],
            },
        }),
        layout.component({
            type: 'sierra',
            props: {
                verticalSpacing: 'gridGap',
                fixedRatios: ['16:9'],
                heroImageLayout: ResponsivePictureLayout.ObjectFitContain,
                cardOrientation: {
                    type: 'Landscape-Portrait',
                    maxBreakpoint: 'md',
                },
                cardLayout: ['hero', 'teaser-xsVisible-mdHidden-Image'],

                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'food',
                    offset: 0,
                    pageSize: 2,
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                teaserMode: 'visible',
                cardOrientation: { type: 'Landscape-Portrait' },

                dataDefinitionArgs: {
                    type: 'curation',
                    name: 'food',
                    offset: 2,
                    pageSize: 4,
                },
            },
        }),

        layout.component({
            type: 'flourish-iframe',
            props: {
                link: 'https://flo.uri.sh/visualisation/10284374/embed',
                height: 800,
                marginBottom: 'lg',
                ariaLabel: 'a scrollable list of food reviews',
                imgHeight: 15,
            },
        }),

        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: 'Drink',
                    section: 'lifestyle',
                    headingUrl: 'drink',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['lifestyle/drink'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: 'Restaurant Reviews',
                    section: 'lifestyle',
                    headingUrl: 'restaurant-reviews',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['lifestyle/restaurant-reviews'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
    ]
}
